const pilotareas = [{"key":"pilotarea.vienna","string":"Vídeň"},{"key":"pilotarea.bratislava","string":"Bratislava – Hainburg – Kittsee"},{"key":"pilotarea.vogtland","string":"Vogtland \/ Z-Čechy"},{"key":"pilotarea.ljubljana","string":"Ljubljana"},{"key":"pilotarea.broumov","string":"Valbřich \/ Broumov"},{"key":"pilotarea.krakow","string":"Krakov"}]

export default pilotareas



// WEBPACK FOOTER //
// ./src/i18n/cs/pilotareas/_pilotareas.js